// src/pages/admin/Dashboard.jsx
import React, { useEffect, useState } from "react";
import styles from "./dashboard.module.css";
import { ref, onValue } from "firebase/database";
import { dimaniwasRtdb } from "../../firebase/config"; // Dimaniwas DB

const Dashboard = () => {
  const [totalTents, setTotalTents] = useState(0);
  const [addedToday, setAddedToday] = useState(0);
  const [addedLast10Days, setAddedLast10Days] = useState(0);

  useEffect(() => {
    const tentsRef = ref(dimaniwasRtdb, "tents");

    onValue(tentsRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) return;

      const tentList = Object.values(data);
      const now = Date.now();
      const oneDay = 86400000;
      const tenDays = oneDay * 10;

      let countToday = 0;
      let count10Days = 0;

      tentList.forEach((tent) => {
        if (tent.createdAt) {
          const diff = now - tent.createdAt;

          if (diff <= oneDay) countToday++;
          if (diff <= tenDays) count10Days++;
        }
      });

      setTotalTents(tentList.length);
      setAddedToday(countToday);
      setAddedLast10Days(count10Days);
    });
  }, []);

  return (
    <div className={styles.container}>
      {/* Top Navigation */}
      <div className={styles.topNav}>
        <div className={styles.logo}>Admin</div>
        <ul className={styles.navList}>
          <li><a href="/admin/dashboard" className={styles.active}>Dashboard</a></li>
          <li><a href="/admin/add-tent">Add Tent</a></li>
          <li><a href="/admin/all-tents">Manage Tents</a></li>
           <li><a href="/admin/add-feature">Add Feature</a></li>
          <li><a href="/admin/all-features">All Features</a></li>
        </ul>
      </div>

      {/* Main Section */}
      <div className={styles.main}>
        <h1 className={styles.heading}>Dashboard Overview</h1>
        <div className={styles.cards}>
          <div className={styles.card}>
            <h3>Total Tents</h3>
            <p>{totalTents}</p>
          </div>
          <div className={styles.card}>
            <h3>Added Today</h3>
            <p>{addedToday}</p>
          </div>
          <div className={styles.card}>
            <h3>Added in Last 10 Days</h3>
            <p>{addedLast10Days}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
